import type { OfferCatalog } from "~/types/offer"
import type { ProductOfferData } from "~/types/product"
import type { RefProductOffer } from "~/types/referral"

/**
 * Format price
 * @param price
 * @returns {string}
 */
export const getFormattedPrice = (price: number): string => {
  if (price === 0) {
    return '0'
  } else if (!price) {
    return ''
  }

  return (Array.from(price.toString()) as string[]).reduce(
    (
      accumulator: string,
      currentValue: string,
      index: number,
      arr: string[]
    ) => {
      const value: string =
        (arr.length - index) % 3 === 0 ? ` ${currentValue}` : currentValue

      return accumulator + value
    },
    ''
  )
}

export const getOfferDiscount = (price: number, oldPrice: number | null) => {
  if (oldPrice) {
    return Math.round((price - oldPrice) / oldPrice * 100)
  } else {
    return 0
  }
}

export const getIsPromoCampaignActive = (offer: OfferCatalog | ProductOfferData | RefProductOffer | null) => {
  const { $dayjs } = useNuxtApp()

  if (offer?.promo && offer.promo.finishes_at) {
    return $dayjs().isAfter(offer.promo.started_at) && $dayjs().isBefore(offer.promo.finishes_at)
  }

  return false
}

export const getCurrentPrice = (offer: OfferCatalog | ProductOfferData | RefProductOffer | null) => {
  const isPromoCampaignActive = getIsPromoCampaignActive(offer)

  if (isPromoCampaignActive && offer?.price_promo) {
    return offer.price_promo
  }

  return offer?.price || 0
}

export const getOldPrice = (offer: OfferCatalog | ProductOfferData | RefProductOffer | null) => {
  const isPromoCampaignActive = getIsPromoCampaignActive(offer)

  if (isPromoCampaignActive && offer?.price_promo) return offer.price

  if (offer?.price_old && offer.price_old > offer.price) return offer.price_old

  return null
}